import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loadinSpinner"
}
const _hoisted_2 = { class: "basic-modal-wrap consent-modal" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = { class: "content-wrapper d-flex" }
const _hoisted_6 = { class: "alert-container d-flex flex-column position-relative" }
const _hoisted_7 = { class: "alert-title" }
const _hoisted_8 = { class: "alert-content" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "alert-inputs mt-3" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = {
  for: "firstName",
  class: "form-label"
}
const _hoisted_15 = { class: "input-group w-100" }
const _hoisted_16 = { class: "row mb-1" }
const _hoisted_17 = { class: "col-md-5" }
const _hoisted_18 = {
  for: "firstName",
  class: "form-label"
}
const _hoisted_19 = { class: "input-group w-100" }
const _hoisted_20 = { class: "row mb-1" }
const _hoisted_21 = { class: "col-md-5" }
const _hoisted_22 = {
  for: "firstName",
  class: "form-label"
}
const _hoisted_23 = { class: "input-group w-100" }
const _hoisted_24 = { class: "row mb-1" }
const _hoisted_25 = { class: "col-md-7" }
const _hoisted_26 = { class: "d-flex gap-2" }
const _hoisted_27 = {
  for: "telephoneNumber",
  class: "form-label"
}
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = { class: "input-group w-100 mb-2" }
const _hoisted_30 = { class: "alert-checkboxes mt-5" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "d-flex gap-3" }
const _hoisted_34 = ["id"]
const _hoisted_35 = ["for"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "row w-100 mx-0 justify-content-center mt-5 mb-5 mb-md-0" }
const _hoisted_39 = {
  key: 0,
  class: "d-flex gap-3 d-md-none"
}
const _hoisted_40 = { class: "px-2" }
const _hoisted_41 = {
  key: 0,
  class: "alert-details"
}
const _hoisted_42 = {
  class: "accordion d-none d-md-block",
  id: "consentsDetails"
}
const _hoisted_43 = { class: "accordion-item" }
const _hoisted_44 = {
  class: "accordion-header",
  id: "headingConsent"
}
const _hoisted_45 = {
  class: "accordion-button bg-transparent text-dark shadow-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseConsent",
  "aria-expanded": "false",
  "aria-controls": "collapseConsent"
}
const _hoisted_46 = {
  id: "collapseConsent",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingConsent",
  "data-bs-parent": "#consentsDetails"
}
const _hoisted_47 = { class: "accordion-body container-fluid" }
const _hoisted_48 = { class: "legend d-flex gap-3" }
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "mt-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_53 = { class: "text-start" }
const _hoisted_54 = ["src"]
const _hoisted_55 = ["src"]
const _hoisted_56 = {
  class: "accordion d-none d-md-block",
  id: "roleMapping"
}
const _hoisted_57 = { class: "accordion-item" }
const _hoisted_58 = {
  class: "accordion-header",
  id: "headingRoleMapping"
}
const _hoisted_59 = {
  class: "accordion-button bg-transparent text-dark shadow-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseRolemapping",
  "aria-expanded": "false",
  "aria-controls": "collapseRolemapping"
}
const _hoisted_60 = {
  id: "collapseRolemapping",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingRoleMapping",
  "data-bs-parent": "#roleMapping"
}
const _hoisted_61 = { class: "accordion-body container-fluid" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "modal-container" }
const _hoisted_64 = { class: "content-wrapper d-flex" }
const _hoisted_65 = { class: "alert-container d-flex flex-column position-relative" }
const _hoisted_66 = { class: "alert-title" }
const _hoisted_67 = { class: "alert-content" }
const _hoisted_68 = { class: "alert-footer row justify-content-end gap-3 w-100 mx-0" }
const _hoisted_69 = { class: "px-2" }
const _hoisted_70 = { class: "px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiSelectBox = _resolveComponent("AsahiSelectBox")!
  const _component_AsahiInput = _resolveComponent("AsahiInput")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_MazPhoneNumberInput = _resolveComponent("MazPhoneNumberInput")!
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_RoleDescription = _resolveComponent("RoleDescription")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoaderSpinner)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["t-modal", {'d-none' : _ctx.hideModal}]),
        onClick: _withModifiers(() => { }, ["stop"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AsahiTypography, {
                  type: "headline-extra-bold font-open-sans mt-5 mt-md-0",
                  color: "",
                  class: "bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Complete your profile')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('Please complete the missing information and confirm that you have familiarized yourself with the updated Prazdroj Online Terms of Use.')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('We’re almost there!')), 1),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('All fields with asterisk (*) are required')), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Salutations')) + "*", 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_AsahiSelectBox, {
                          "h-fill-option": true,
                          "full-width": true,
                          defaultLabel: _ctx.$t('Select an option'),
                          modelValue: _ctx.selectedGender,
                          isValid: _ctx.isGenderSelected,
                          options: _ctx.genderList,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => { _ctx.handleGenderSelection(value) })
                        }, null, 8, ["defaultLabel", "modelValue", "isValid", "options"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('First name')), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_AsahiInput, {
                          "placeholder-class": 'subtitle-bold',
                          class: "w-100",
                          id: "firstName",
                          value: _ctx.user.firstName,
                          readonly: true,
                          disabled: true,
                          "input-bold": true
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('Last name')), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_AsahiInput, {
                          "placeholder-class": 'subtitle-bold',
                          class: "w-100",
                          id: "lastName",
                          value: _ctx.user.lastName,
                          readonly: true,
                          disabled: true,
                          "input-bold": true
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('Telephone number')) + " " + _toDisplayString(_ctx.isKeyUser ? '*' : ''), 1),
                        (_ctx.user.phone !== '' && _ctx.user.phone )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "d-inline-flex ml-4 asahi-link",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args)))
                            }, [
                              _createVNode(_component_EditIcon, { class: "primary-gold" }),
                              _createVNode(_component_AsahiTypography, {
                                type: 'subtitle-3-bold',
                                color: "primary-gold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(!_ctx.editNumber ? _ctx.$t('Modify') :  _ctx.$t('Cancel')), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_AsahiTypography, { type: "subtitle-2-bold" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('By providing your phone number, you help us stay in touch with you for the purpose of our business cooperation.')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        ((_ctx.user.phone === '' || !_ctx.user.phone) || _ctx.editNumber)
                          ? (_openBlock(), _createBlock(_component_MazPhoneNumberInput, {
                              key: 0,
                              error: _ctx.editNumber && !_ctx.isValidPhone && !_ctx.isFirstTouachPhoneInput,
                              orientation: "row",
                              class: _normalizeClass(["asahi-number-input", {'is-sk': _ctx.isActiveLanguageSK && !_ctx.isFirstTouachPhoneInput}]),
                              "show-code-on-list": "",
                              color: "info",
                              onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkPhoneNumber($event))),
                              "default-country-code": _ctx.countryCode,
                              translations: {
                            countrySelector: {
                              placeholder: '',
                              error: _ctx.$t('Country error'),
                              searchPlaceholder: _ctx.$t('Select country'),
                            },
                            phoneInput: {
                              placeholder: _ctx.$t(''),
                              example: _ctx.$t('Example'),
                            },
                          }
                            }, null, 8, ["error", "class", "default-country-code", "translations"]))
                          : (_openBlock(), _createBlock(_component_AsahiInput, {
                              key: 1,
                              "placeholder-class": 'subtitle-bold',
                              class: "w-100",
                              id: "telephoneNumber",
                              value: _ctx.user.phone,
                              "input-bold": true,
                              disabled: true
                            }, null, 8, ["value"]))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consentsData, (consent) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: consent.title,
                      class: "mb-5"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", {
                          innerHTML: consent.titleText
                        }, null, 8, _hoisted_31),
                        _createElementVNode("p", {
                          innerHTML: consent.subtitleText
                        }, null, 8, _hoisted_32),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "terms-and-policy-checkbox",
                            id: consent.title,
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAcceptedCheckbox($event)))
                          }, null, 40, _hoisted_34),
                          _createElementVNode("label", {
                            for: consent.title,
                            class: "cursor-pointer"
                          }, [
                            (consent.titleContent)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "ml-2",
                                  innerHTML: consent.titleContent
                                }, null, 8, _hoisted_36))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_35)
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.isKeyUser)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t('Communication Distribution Settings label')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.isKeyUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createVNode(_component_InfoIcon),
                          _createElementVNode("p", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('Please check recommended setting and role permission mapping  on desktop')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_AsahiButton, {
                      class: "col-md-4",
                      type: "primary",
                      disabled: _ctx.isProceedDisabled,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('Proceed')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                (_ctx.isKeyUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("h2", _hoisted_44, [
                            _createElementVNode("button", _hoisted_45, [
                              _createVNode(_component_AsahiTypography, {
                                type: "title-1-bold",
                                color: "primary-black"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('RECOMMENDED SETTINGS')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_AsahiTypography, {
                                type: "subtitle",
                                color: "primary-light-green",
                                class: "mt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Legends')) + ": ", 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("img", {
                                    src: _ctx.checkRingSvgIcon,
                                    alt: "icon"
                                  }, null, 8, _hoisted_49),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Yes')), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("img", {
                                    src: _ctx.minusCircleSvgIcon,
                                    alt: "icon"
                                  }, null, 8, _hoisted_50),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('No')), 1)
                                ])
                              ]),
                              _createElementVNode("table", _hoisted_51, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_52,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                                      return (_openBlock(), _createElementBlock("th", { key: role }, _toDisplayString(_ctx.$t(role)), 1))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (row) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: row.label
                                    }, [
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.$t(row.label)), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.values, (value, index) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: index,
                                          class: "text-center icon-cell"
                                        }, [
                                          (value == true || value === null)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: _ctx.checkRingSvgIcon,
                                                alt: "icon"
                                              }, null, 8, _hoisted_54))
                                            : (value === false)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 1,
                                                  src: _ctx.minusCircleSvgIcon,
                                                  alt: "icon"
                                                }, null, 8, _hoisted_55))
                                              : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("h2", _hoisted_58, [
                            _createElementVNode("button", _hoisted_59, [
                              _createVNode(_component_AsahiTypography, {
                                type: "title-1-bold",
                                color: "primary-black"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('ROLE PERMISSION MAPPING')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              (_ctx.customerType)
                                ? (_openBlock(), _createBlock(_component_RoleDescription, {
                                    key: 0,
                                    isConsentPopup: true,
                                    customerType: _ctx.customerType.customerType
                                  }, null, 8, ["customerType"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ], 10, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass(["w-modal", {'d-none' : !_ctx.hideModal}]),
        onClick: _withModifiers(() => { }, ["stop"])
      }, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_AsahiTypography, {
                  type: "headline-extra-bold  font-open-sans",
                  color: "",
                  class: "bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Marketing Consent Not Selected')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('Are you sure you don’t want to receive updates about discounts and Prazdroj news tailored for you? You may miss out on exclusive offers and updates prepared for our partners.')), 1)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_AsahiButton, {
                  class: "col-12 col-md-auto",
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.proceed()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('SKIP FOR NOW')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_AsahiButton, {
                  class: "col-12 col-md-auto",
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goBack()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$t('GO BACK TO GIVE CONSENT')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ], 10, _hoisted_62)
    ])
  ], 64))
}